import { getBreakPoints, mediaQueryWidth } from '@core/styles/helpers'
import styled from '@emotion/styled'

export const Flex = styled.div`
  display: flex;
  justify-content: ${({ justify }) => justify || 'inherit'};
  align-items: ${({ align }) => align || 'center'};
  height: 100%;

  &.admin-header {
    .header-system-name {
      margin-right: 0;
    }

    .header-locale {
      display: none;

      ${mediaQueryWidth('xs')} {
        display: block;
      }
    }

    @media not all and (min-width: ${getBreakPoints('md', true)}) {
      gap: 8px;
      font-size: clamp(12px, 2.7vw, 16px);
      line-height: 1.4;

      .header-brand {
        flex: 0 0 auto;
        gap: 6px;
        white-space: nowrap;
      }

      .header-account {
        flex: 1;
        min-width: 0;
        gap: 8px;
        justify-content: flex-end;
      }

      .header-brand > *,
      .header-account > * {
        margin-right: 0;
        flex-shrink: 0;
      }

      .header-user-name {
        min-width: 0;
        flex-shrink: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .locale-content {
        margin: 0;
      }
    }
  }
`
export const HeaderMenu = styled(Flex)`
  & > * {
    margin-right: 15px;

    &:last-of-type {
      margin-right: 0;
    }
  }

  :first-of-type {
    .ess-icon {
      display: block;

      ${mediaQueryWidth('md')} {
        display: none;
      }
    }
  }
`
